<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- sidebar -->
    <sidebar></sidebar>
    <a-layout>
      <a-layout-content :style="{ margin: '16px', padding: '24px', minHeight: '100vh' }">
        <a-row :gutter="40">
          <a-col :span="6" class="gutter-row">
            <h2>Stats</h2>
          </a-col>
        </a-row>
<!--        <template v-if="loading">-->
<!--          <div class="loader-container">-->
<!--            <a-spin :size="'large'"/>-->
<!--          </div>-->
<!--        </template>-->
        <template>
          <div>
            <a-row :gutter="16">
              <a-col :span="8">
                <StatCardComponent :filter-stat-value="filterNewUser" :stat-value="users" title="New Users"
                                   :stat-filter="newUsersFilter" @update-filter="handleFilterUpdate('newUsers', $event)"/>
              </a-col>
              <a-col :span="8">
                <StatCardComponent :filter-stat-value="filterFreeSite" :stat-value="freeSite" title="Free Sites"
                                   :stat-filter="freeSiteFilter" @update-filter="handleFilterUpdate('freeSite', $event)"/>
              </a-col>
              <a-col :span="8">
                <StatCardComponent :filter-stat-value="filterProSite" :stat-value="proSite" title="Pro Sites"
                                   :stat-filter="proSiteFilter" @update-filter="handleFilterUpdate('proSite', $event)"/>
              </a-col>
            </a-row>
            <a-row :gutter="16" style="margin-top: 10px">
              <a-col :span="8">
                <StatCardComponent :filter-stat-value="filterCompletedCampaign" :stat-value="completedCampaign" title="Total Campaigns Successfully Sent"
                                   :stat-filter="completedCampaignFilter" @update-filter="handleFilterUpdate('completedCampaign', $event)"/>
              </a-col>
              <a-col :span="8">
                <StatCardComponent :filter-stat-value="filterConversionRate" :stat-value="conversionRate" title="Conversion Rate" :show-filter="false"/>
              </a-col>
            </a-row>
          </div>
          <!--          <a-row :gutter="40">-->
          <!--            <doughnut-chart-->
          <!--              :loading="openClickBounceLoader"-->
          <!--              pchart-title="Open VS Click VS Bounce"-->
          <!--              pchart-link="/admin/stats/open-click-bounce"-->
          <!--              :pchart-data="openClickBounce.values"-->
          <!--              :pchart-labels="openClickBounce.labels"-->
          <!--              pchart-type="pie"-->
          <!--              PchartGereratedId="open-click"-->
          <!--              :pbg-color="['#c5dd62','#d2a0ef','#ff00e7']"-->
          <!--              @daysChanged="openClickBounceDaysChanged"-->
          <!--              :selected="openClickBounceSelection"-->
          <!--            ></doughnut-chart>-->
          <!--            <doughnut-chart-->
          <!--              :loading="subscribeUnsubscribeLoader"-->
          <!--              pchart-title="Subscribe VS Unsubscribe"-->
          <!--              pchart-link="/admin/stats/subscribe-unsubscribe"-->
          <!--              :pchart-data="subscribeUnsubscribe.values"-->
          <!--              :pchart-labels="subscribeUnsubscribe.labels"-->
          <!--              pchart-type="pie"-->
          <!--              PchartGereratedId="subscribe-unsubscribe"-->
          <!--              :pbg-color="['#2a6ebc','#9aa1ce']"-->
          <!--              @daysChanged="subscribeUnsubscribeDaysChanged"-->
          <!--              :selected="subscribeUnsubscribeSelection"-->
          <!--            ></doughnut-chart>-->
          <!--          </a-row>-->

          <a-row :style="{ marginTop: '25px' }" :gutter="40">
            <a-col
                :xs="{ span : 24 }"
                :md="{ span : 24 }"
                style="margin-bottom: 10px;"
                class="gutter-row"
            >
              <a-card a-card title="Emails Sending Rate" class="Custom--Card" :loading="emailSendingLoader">
                <a-select v-model="sendingRateHours" slot="extra" @change="handleEmailSendingRateInTime">
                  <a-select-option value="1" key="-1">Last 1 Hour</a-select-option>
                  <a-select-option v-for="(hour, index) in noOfHours" :key="index" :value="hour">Last {{ hour }} Hours
                  </a-select-option>
                  <a-select-option value="24" key="24">Last 1 Day</a-select-option>
                  <a-select-option value="48" key="48">Last 2 Days</a-select-option>
                  <a-select-option value="168" key="168">Last 7 Days</a-select-option>
                  <a-select-option value="720" key="720">Last 30 Days</a-select-option>
                </a-select>
                <line-graph :labels="emailsPerMinute.labels" :values="emailsPerMinute.values" color="red"></line-graph>
              </a-card>
            </a-col>
          </a-row>

          <a-row :style="{background:'#fff', marginLeft: '3px', marginRight: '3px', marginTop: '25px'}">
            <a-card a-card title="Overall Subscribers" class="Custom--Card" :loading="overallSubscribersLoader">
              <a-select v-model="overallSubscriberDays" slot="extra" @change="handleOverallSubscribers">
                <a-select-option value="last-30-days">Last 30 Days</a-select-option>
                <a-select-option value="last-month">Last Month</a-select-option>
                <a-select-option value="last-7-days">Last 7 Days</a-select-option>
              </a-select>
              <overall-subscribers-graph
                  :labels="overallSubscribers.labels"
                  :values="overallSubscribers.values"
                  color="#E68B3A"
              ></overall-subscribers-graph>
            </a-card>
          </a-row>
        </template>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import LineGraph from "@/components/LineGraph";
import OverallSubscribersGraph from "@/components/OverallSubscribersGraph";
import {mapGetters, mapState} from 'vuex';
import StatCardComponent from "@/views/Stats/StatCardComponent.vue";

export default {
  data() {
    return {
      loading: true,
      sendingRateHours: '1',
      overallSubscriberDays: "last-7-days",
      openClickBounceSelection: 'last-7-days',
      subscribeUnsubscribeSelection: 'last-7-days',
      interval: null,
      emailSendingLoader: false,
      overallSubscribersLoader: false,
      openClickBounceLoader: false,
      subscribeUnsubscribeLoader: false,
      newUsersFilter: '30-days',
      freeSiteFilter: '30-days',
      proSiteFilter: '30-days',
      completedCampaignFilter: '30-days',
    }
  },
  components: {
    StatCardComponent,
    Sidebar,
    LineGraph,
    OverallSubscribersGraph
  },
  computed: {
    ...mapGetters({
      openClickBounce: 'stats/getOpenClickBouncePieChartData',
      subscribeUnsubscribe: 'stats/getSubscribeUnsubscribePieChartData',
      emailsPerMinute: 'stats/getEmailsPerMinute',
      overallSubscribers: 'stats/getOverallSubscribers',
    }),
    ...mapState("stats", ['users', 'freeSite', 'proSite', 'conversionRate', 'completedCampaign']),
    noOfHours() {
      const hours = [];
      for (var i = 2; i <= 23; i++) {
        hours.push(i);
      }
      return hours;
    }
  },
  methods: {
    getQueryString(filterType, filter) {
      this.loading = true;

      // eslint-disable-next-line no-unused-vars
      let refresh = false;

      if (filter === 'refresh') {
        refresh = true;
      } else {
        this[filterType] = filter;
      }
      return refresh;
    },

    filterNewUser(filter) {
      let refresh = this.getQueryString(this.newUsersFilter, filter);
      this.$store.dispatch("stats/GET_USERS", {
        query: this.newUsersFilter,
        refresh: refresh
      }).then(() => this.loading = false);
    },

    filterFreeSite(filter) {
      let refresh = this.getQueryString(this.freeSiteFilter, filter);

      this.$store.dispatch("stats/GET_FREE_SITE", {
        query: this.freeSiteFilter,
        refresh: refresh
      }).then(() => this.loading = false);
    },

    filterProSite(filter) {
      let refresh = this.getQueryString(this.proSiteFilter, filter);

      this.$store.dispatch("stats/GET_PRO_SITE", {
        query: this.proSiteFilter,
        refresh: refresh
      }).then(() => this.loading = false);
    },

    filterCompletedCampaign(filter) {
      let refresh = this.getQueryString(this.completedCampaignFilter, filter);

      this.$store.dispatch("stats/GET_COMPLETED_CAMPAIGN", {
        query: this.completedCampaignFilter,
        refresh: refresh
      }).then(() => this.loading = false);
    },

    filterConversionRate(filter) {
      this.loading = true;

      // eslint-disable-next-line no-unused-vars
      let refresh = filter === 'refresh';

      this.$store.dispatch("stats/GET_CONVERSION_RATE_SITE", {
        refresh: refresh
      }).then(() => this.loading = false);
    },

    // TODO: Temporarily hide this pie chart as the table it currently uses is deprecated.
    // openClickBounceDaysChanged(param) {
    //   this.openClickBounceSelection = param;
    //   this.getOpenClickGraphData({q: param});
    // },
    // subscribeUnsubscribeDaysChanged(param) {
    //   this.subscribeUnsubscribeSelection = param;
    //   this.subscribeUnsubscribeGraphData({q: param});
    // },

    // Pie chart data
    // async getOpenClickGraphData(params = {q: 'last-7-days'}, loading = false) {
    //   if (loading) {
    //     this.openClickBounceLoader = true;
    //   }
    //   await this.$store.dispatch('stats/OPEN_CLICK_BOUNCE_PIE_CHART_DATA', params);
    //   if (loading) {
    //     this.openClickBounceLoader = false;
    //   }
    // },
    // async subscribeUnsubscribeGraphData(params = {q: 'last-7-days'}, loading = false) {
    //   if (loading) {
    //     this.subscribeUnsubscribeLoader = true;
    //   }
    //   await this.$store.dispatch('stats/SUBSCRIBE_UNSUBSCRIBE_PIE_CHART_DATA', params);
    //   if (loading) {
    //     this.subscribeUnsubscribeLoader = false;
    //   }
    // },
    // get email sending rate action from store
    async getEmailSendingRate(params = {hours: 1}, loading = false) {
      if (loading) {
        this.emailSendingLoader = true;
      }
      await this.$store.dispatch('stats/GET_EMAILS_PER_MINUTE_FroM_API', params);
      if (loading) {
        this.emailSendingLoader = false;
      }
      this.interval = setTimeout(() => {
        this.getEmailSendingRate({hours: this.sendingRateHours}, false);
      }, 60000);
    },
    // dispatch overall subscribers action from store
    async getOverallSubscribers(params = {q: 'last-7-days'}, loading = false) {
      if (loading) {
        this.overallSubscribersLoader = true;
      }
      await this.$store.dispatch('stats/GET_OVERALL_SUBSCRIBERS_FroM_API', params);
      if (loading) {
        this.overallSubscribersLoader = false;
      }
    },
    // Email sending reate on change event
    handleEmailSendingRateInTime() {
      this.getEmailSendingRate({hours: this.sendingRateHours}, true);
    },
    // Overall subscribers on change event
    handleOverallSubscribers(q) {
      this.getOverallSubscribers({q: q}, true);
    },
    // dispatch all actions
    async dispatchActions() {
      this.loading = true;
      await this.getEmailSendingRate();
      await this.getOverallSubscribers();
      // await this.getOpenClickGraphData();
      // await this.subscribeUnsubscribeGraphData();
      this.$store.dispatch("stats/GET_USERS", this.newUsersFilter);
      this.$store.dispatch("stats/GET_FREE_SITE", this.freeSiteFilter);
      this.$store.dispatch("stats/GET_PRO_SITE", this.proSiteFilter);
      this.$store.dispatch("stats/GET_CONVERSION_RATE_SITE", {});
      this.$store.dispatch("stats/GET_COMPLETED_CAMPAIGN", this.completedCampaignFilter);
      this.loading = false;
    },
    handleFilterUpdate(filterType, value) {
      this[`${filterType}Filter`] = value;
    },
  },
  created() {
    this.dispatchActions();
  },
  destroyed() {
    clearTimeout(this.interval);
  }
};
</script>
